export default {
    personal: {
        email: '',
        phoneNumber: '',
        gender: '',
        title: '',
        firstName: '',
        lastName: '',
        fullName: '',
        dateOfBirth: '',
        countryOfBirth: '',
        hasOtherNationality: '',
        nationality: '',
        nationality2: '',
        nationality3: '',
        documentType: '',
        dateOfExpiry: '',
        prcIdNumber: '',
        chineseLegalName: '',
        placeOfIssue: '',
        permitNumber: ''
    }
}
